import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
export default gql(`
  subscription commentReactionCreated($postId: ID!) {
    commentReaction: commentReactionCreated(postId: $postId) {
      ...CommentReactionFields
      commentId
      threadId
    }
  }
`);
